/*
Sohel 10/29/2023 5314488544 title change for add notes dialoge box
Sohel 10/30/2023 5314488544 Added Eligibilty Status Field Data integerated Look up
Sohel 10/27/2023 5314488544 added status and loading issue fix
Sohel 10/30/2023 5314488544 data format issue and fetching table data issue fix
Sohel 10/30/2023 5314488544 Save notes payload changes
Sohel 10/30/2023 5314488544 Added eligibiltySummaryID in save payload and get api
Sohel 10/30/2023 5314488544 Added Loading bar in notes table
Sohel 11/01/2023 5314488544 Added status field dropDownData
Sohel 11/01/2023 5314488544 notes payload changes
sohel 06/11/2023 5314488544 account status table api call 
sohel 11/08/2023 5314488544 title name change Reviewed Status title
sohel 11/10/2023 5314488544 table notes tooltip added for extra notes data 
*/
import React, { useState, useEffect } from "react";
import { TablePagination, Button, Grid } from "@material-ui/core";
import { tableIcons } from "../../../components/TableIcons";
import { useDispatch, useSelector } from "react-redux";
import { defaultRows } from "../../../constants/ReusableTablePagination";
import AddUserDefinedNotes from "../../../components/AddUserDefinedNotes";
import GuiTable from "../../../components/FormComponents/GuiTable";
import { tablePageRows } from "../../../constants/ReusableConstants";
import DialogBox from "../../../components/DialogBox/index";

import {
  getEligibleScrubNotes,
  postEligibleScrubData,
  eligibleScrubNotesReset,
  resetPostStatus,
  getDropDownData,
  fetchEligibleScrubAllData,
} from "../../../redux/reducers/EligibiltyScrubs";
import { SuccessSnackbar } from "../../../components/CustomSnackBar";
import PageLoader from "../../../components/PageLoader";


const EligibiltyNotes = ({ eligibilitySummaryId, accountNumber }) => {
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const {
    getNotesData,
    isEligibleNotesStatus,
    isEligibleNotesLoading,
    successMsg,
    isLoading,
    dropDownData,
  } = useSelector(({ eligibleScrub }) => eligibleScrub);

  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    if (isEligibleNotesStatus === 200) {
      handleDialogClose();
      dispatch(resetPostStatus());
      dispatch(fetchEligibleScrubAllData(accountNumber));
      setTimeout(() => {
        dispatch(getEligibleScrubNotes(eligibilitySummaryId));
        dispatch(eligibleScrubNotesReset());
      }, 1500);
    }
  }, [isEligibleNotesStatus]);
  const dispatchRecordFormatSystemNotes = (data, status) => {
    dispatch(
      postEligibleScrubData({
        eligibilitySummaryId: eligibilitySummaryId ? eligibilitySummaryId : '',
        notes: data,
        reviewStatus: status?.eligibleStatus?.value ? status?.eligibleStatus?.value : '',
      }),
    );
  };

  useEffect(() => {
    if (eligibilitySummaryId) {
      dispatch(getEligibleScrubNotes(eligibilitySummaryId));
    }
  }, [eligibilitySummaryId]);
  let transcription = '';
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Review By',
      field: 'reviewBy',
    },
    {
      title: 'Review Date',
      field: 'reviewDate',
      render: (rowData) => {
        return rowData?.reviewDate ? moment(rowData?.reviewDate).format('MM/DD/YYYY') : '-';
      },
    },
    {
      title: 'Review Status',
      field: 'reviewStatus',
    },
    {
      title: 'Notes',
      field: 'notes',
      cellStyle: {
        minWidth: '550px',
        // maxWidth: '450px',
        whiteSpace: 'normal !important',
      },
      render: (rowData) =>  <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{rowData?.notes?.split(',').join(', ')}</span>
    },
  ];

  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const { roleData } = useSelector(({ role }) => role);

  const reportMasterDisableAdd = roleData?.window?.['Business Rule Engine']?.['BR'];

  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  return (
    <>
      <DialogBox
        title="Add Review Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isEligibleNotesLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            reportMasterDisableAdd={reportMasterDisableAdd}
            eligibiltyScrubScreen={true}
            dropDownData={dropDownData}
          />
        )}
      </DialogBox>
      <Grid className="system-notes-dialog">
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={getNotesData.length > 0 ? getNotesData?.map((item) => ({ ...item })) : []}
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button variant="outlined" className="search-btn">
                      Review
                    </Button>
                  </div>
                ),
                isFreeAction: true,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
          />
        </div>
      </Grid>
      {isLoading && <PageLoader />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default EligibiltyNotes